"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var qrcode_react_1 = __importDefault(require("qrcode.react"));

var BurnerProvider_1 = require("../../BurnerProvider");

var Page_1 = __importDefault(require("../../components/Page"));

var classes = require('./ReceivePage.module.css');

var ReceivePage = function ReceivePage(_a) {
  var accounts = _a.accounts;

  var _b = react_1.useState(false),
      showCopied = _b[0],
      setShowCopied = _b[1];

  return react_1.default.createElement(Page_1.default, {
    title: "Receive"
  }, accounts.length > 0 && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: classes.qrContainer
  }, react_1.default.createElement(qrcode_react_1.default, {
    value: accounts[0],
    renderAs: "svg"
  })), react_1.default.createElement("div", {
    className: classes.addressContainer
  }, react_1.default.createElement("input", {
    value: accounts[0],
    readOnly: true,
    className: classes.address,
    onClick: function onClick() {
      navigator.clipboard.writeText(accounts[0]);
      setShowCopied(true);
      setTimeout(function () {
        return setShowCopied(false);
      }, 5000);
    }
  })), react_1.default.createElement("div", {
    className: showCopied ? classes.copied : classes.copyHidden
  }, "Address copied to clipboard")));
};

exports.default = BurnerProvider_1.withBurner(ReceivePage);